export default "__VITE_ASSET__84c59475__"